import { useFormContext, Controller } from "react-hook-form";
import type { CheckboxProps } from "antd/lib";
import type { FC } from "react";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { AppCheckbox } from "../../AppCheckbox";

export const FormCheckbox: FC<CheckboxProps> = ({ name = "", ...props }) => {
  const { control } = useFormContext();
  return (
    <FormFieldWrapper name={name}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <AppCheckbox onChange={onChange} checked={value} ref={ref} {...props} />
        )}
      />
    </FormFieldWrapper>
  );
};
